import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

const OFERTA_LABORAL_PREFIX = /^\/?oferta-laboral\//;

/**
 * Legacy vacancy slugs can carry raw parentheses (`/oferta-laboral/ventas-(cdmx)`). The default
 * parser reads `(` as the start of a named outlet, fails to match and falls to the `**` route
 * (issue #1881). Under /oferta-laboral/ only, the parentheses of the path are pre-encoded as
 * `%28 %29`, which the default parser decodes once into the slug. Query, fragment and every other
 * URL go through the default parser untouched; `serialize` is inherited.
 */
@Injectable()
export class OfertaLaboralUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    if (!OFERTA_LABORAL_PREFIX.test(url)) {
      return super.parse(url);
    }
    const tail = url.search(/[?#]/);
    const path = tail === -1 ? url : url.slice(0, tail);
    const rest = tail === -1 ? '' : url.slice(tail);
    return super.parse(path.replace(/\(/g, '%28').replace(/\)/g, '%29') + rest);
  }
}
